import { useEffect, useCallback } from "react";
export function usePreventContextMenu() {
  const on = useCallback(() => {
    document.body.oncontextmenu = () => false;
    document.body.ondragstart = () => false;
  }, []);
  const off = useCallback(() => {
    document.body.oncontextmenu = "";
    document.body.ondragstart = "";
  }, []);
  useEffect(() => {
    on();
  }, []);
  return [on, off];
}